"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCursor = exports.getNewStyle = exports.degToRadian = exports.getAngle = exports.getLength = void 0;

var getLength = function getLength(x, y) {
  return Math.sqrt(x * x + y * y);
};

exports.getLength = getLength;

var getAngle = function getAngle(_ref, _ref2) {
  var x1 = _ref.x,
      y1 = _ref.y;
  var x2 = _ref2.x,
      y2 = _ref2.y;
  var dot = x1 * x2 + y1 * y2;
  var det = x1 * y2 - y1 * x2;
  var angle = Math.atan2(det, dot) / Math.PI * 180;
  return (angle + 360) % 360;
};

exports.getAngle = getAngle;

var degToRadian = function degToRadian(deg) {
  return deg * Math.PI / 180;
};

exports.degToRadian = degToRadian;

var cos = function cos(deg) {
  return Math.cos(degToRadian(deg));
};

var sin = function sin(deg) {
  return Math.sin(degToRadian(deg));
};

var setWidthAndDeltaW = function setWidthAndDeltaW(width, deltaW, minWidth) {
  var expectedWidth = width + deltaW;

  if (expectedWidth > minWidth) {
    width = expectedWidth;
  } else {
    deltaW = minWidth - width;
    width = minWidth;
  }

  return {
    width: width,
    deltaW: deltaW
  };
};

var setHeightAndDeltaH = function setHeightAndDeltaH(height, deltaH, minHeight) {
  var expectedHeight = height + deltaH;

  if (expectedHeight > minHeight) {
    height = expectedHeight;
  } else {
    deltaH = minHeight - height;
    height = minHeight;
  }

  return {
    height: height,
    deltaH: deltaH
  };
};

var getNewStyle = function getNewStyle(type, rect, deltaW, deltaH, ratio, minWidth, minHeight) {
  var width = rect.width,
      height = rect.height,
      centerX = rect.centerX,
      centerY = rect.centerY,
      rotateAngle = rect.rotateAngle;
  var widthFlag = width < 0 ? -1 : 1;
  var heightFlag = height < 0 ? -1 : 1;
  width = Math.abs(width);
  height = Math.abs(height);

  switch (type) {
    case 'r':
      {
        var widthAndDeltaW = setWidthAndDeltaW(width, deltaW, minWidth);
        width = widthAndDeltaW.width;
        deltaW = widthAndDeltaW.deltaW;

        if (ratio) {
          deltaH = deltaW / ratio;
          height = width / ratio;
          centerX += deltaW / 2 * cos(rotateAngle) - deltaH / 2 * sin(rotateAngle);
          centerY += deltaW / 2 * sin(rotateAngle) + deltaH / 2 * cos(rotateAngle);
        } else {
          centerX += deltaW / 2 * cos(rotateAngle);
          centerY += deltaW / 2 * sin(rotateAngle);
        }

        break;
      }

    case 'tr':
      {
        deltaH = -deltaH;

        var _widthAndDeltaW = setWidthAndDeltaW(width, deltaW, minWidth);

        width = _widthAndDeltaW.width;
        deltaW = _widthAndDeltaW.deltaW;
        var heightAndDeltaH = setHeightAndDeltaH(height, deltaH, minHeight);
        height = heightAndDeltaH.height;
        deltaH = heightAndDeltaH.deltaH;

        if (ratio) {
          deltaW = deltaH * ratio;
          width = height * ratio;
        }

        centerX += deltaW / 2 * cos(rotateAngle) + deltaH / 2 * sin(rotateAngle);
        centerY += deltaW / 2 * sin(rotateAngle) - deltaH / 2 * cos(rotateAngle);
        break;
      }

    case 'br':
      {
        var _widthAndDeltaW2 = setWidthAndDeltaW(width, deltaW, minWidth);

        width = _widthAndDeltaW2.width;
        deltaW = _widthAndDeltaW2.deltaW;

        var _heightAndDeltaH = setHeightAndDeltaH(height, deltaH, minHeight);

        height = _heightAndDeltaH.height;
        deltaH = _heightAndDeltaH.deltaH;

        if (ratio) {
          deltaW = deltaH * ratio;
          width = height * ratio;
        }

        centerX += deltaW / 2 * cos(rotateAngle) - deltaH / 2 * sin(rotateAngle);
        centerY += deltaW / 2 * sin(rotateAngle) + deltaH / 2 * cos(rotateAngle);
        break;
      }

    case 'b':
      {
        var _heightAndDeltaH2 = setHeightAndDeltaH(height, deltaH, minHeight);

        height = _heightAndDeltaH2.height;
        deltaH = _heightAndDeltaH2.deltaH;

        if (ratio) {
          deltaW = deltaH * ratio;
          width = height * ratio;
          centerX += deltaW / 2 * cos(rotateAngle) - deltaH / 2 * sin(rotateAngle);
          centerY += deltaW / 2 * sin(rotateAngle) + deltaH / 2 * cos(rotateAngle);
        } else {
          centerX -= deltaH / 2 * sin(rotateAngle);
          centerY += deltaH / 2 * cos(rotateAngle);
        }

        break;
      }

    case 'bl':
      {
        deltaW = -deltaW;

        var _widthAndDeltaW3 = setWidthAndDeltaW(width, deltaW, minWidth);

        width = _widthAndDeltaW3.width;
        deltaW = _widthAndDeltaW3.deltaW;

        var _heightAndDeltaH3 = setHeightAndDeltaH(height, deltaH, minHeight);

        height = _heightAndDeltaH3.height;
        deltaH = _heightAndDeltaH3.deltaH;

        if (ratio) {
          height = width / ratio;
          deltaH = deltaW / ratio;
        }

        centerX -= deltaW / 2 * cos(rotateAngle) + deltaH / 2 * sin(rotateAngle);
        centerY -= deltaW / 2 * sin(rotateAngle) - deltaH / 2 * cos(rotateAngle);
        break;
      }

    case 'l':
      {
        deltaW = -deltaW;

        var _widthAndDeltaW4 = setWidthAndDeltaW(width, deltaW, minWidth);

        width = _widthAndDeltaW4.width;
        deltaW = _widthAndDeltaW4.deltaW;

        if (ratio) {
          height = width / ratio;
          deltaH = deltaW / ratio;
          centerX -= deltaW / 2 * cos(rotateAngle) + deltaH / 2 * sin(rotateAngle);
          centerY -= deltaW / 2 * sin(rotateAngle) - deltaH / 2 * cos(rotateAngle);
        } else {
          centerX -= deltaW / 2 * cos(rotateAngle);
          centerY -= deltaW / 2 * sin(rotateAngle);
        }

        break;
      }

    case 'tl':
      {
        deltaW = -deltaW;
        deltaH = -deltaH;

        var _widthAndDeltaW5 = setWidthAndDeltaW(width, deltaW, minWidth);

        width = _widthAndDeltaW5.width;
        deltaW = _widthAndDeltaW5.deltaW;

        var _heightAndDeltaH4 = setHeightAndDeltaH(height, deltaH, minHeight);

        height = _heightAndDeltaH4.height;
        deltaH = _heightAndDeltaH4.deltaH;

        if (ratio) {
          width = height * ratio;
          deltaW = deltaH * ratio;
        }

        centerX -= deltaW / 2 * cos(rotateAngle) - deltaH / 2 * sin(rotateAngle);
        centerY -= deltaW / 2 * sin(rotateAngle) + deltaH / 2 * cos(rotateAngle);
        break;
      }

    case 't':
      {
        deltaH = -deltaH;

        var _heightAndDeltaH5 = setHeightAndDeltaH(height, deltaH, minHeight);

        height = _heightAndDeltaH5.height;
        deltaH = _heightAndDeltaH5.deltaH;

        if (ratio) {
          width = height * ratio;
          deltaW = deltaH * ratio;
          centerX += deltaW / 2 * cos(rotateAngle) + deltaH / 2 * sin(rotateAngle);
          centerY += deltaW / 2 * sin(rotateAngle) - deltaH / 2 * cos(rotateAngle);
        } else {
          centerX += deltaH / 2 * sin(rotateAngle);
          centerY -= deltaH / 2 * cos(rotateAngle);
        }

        break;
      }
  }

  return {
    position: {
      centerX: centerX,
      centerY: centerY
    },
    size: {
      width: width * widthFlag,
      height: height * heightFlag
    }
  };
};

exports.getNewStyle = getNewStyle;

var getCursor = function getCursor(rotateAngle, d) {
  var startMap = {
    n: 0,
    ne: 1,
    e: 2,
    se: 3,
    s: 4,
    sw: 5,
    w: 6,
    nw: 7
  };
  var directionArray = ['n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'];
  var map = {
    0: 0,
    1: 1,
    2: 2,
    3: 2,
    4: 3,
    5: 4,
    6: 4,
    7: 5,
    8: 6,
    9: 6,
    10: 7,
    11: 8
  };
  var increment = map[Math.floor(rotateAngle / 30)];
  var index = startMap[d];
  var newIndex = (index + increment) % 8;
  return directionArray[newIndex];
};

exports.getCursor = getCursor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-resizable-rotatable-draggable/lib/utils.js
// module id = 391
// module chunks = 0